import ValidatedValueCard from "@/components/Shared/ValidatedValueCard";
import clsx from "classnames";
import useOurSchoolTopics from "hooks/useOurSchoolTopics";
import { Container } from "reactstrap";
import styles from "./styles.module.scss";

import FooterWave2Icon from "/public/site-assets/svg/footer-wave-2.svg";

export const ImageWithText = ({
  className,
  heading,
  content,
  image,
  lead_content,
  showSchoolTopics,
  items,
  showWave,
  waveDirection,
  waveColor,
  waveBackground,
  showTopWave,
  topWaveDirection,
  topWaveColor,
  topWaveBackground,
}) => {
  const post = useOurSchoolTopics();
  const postsToRender = items && items.length > 0 ? items : post;

  return (
    <>
      {showTopWave && (
        <div
          className={clsx(
            "footer",
            topWaveDirection === "down" && "rotate",
            topWaveColor,
            topWaveBackground,
          )}
          style={{ marginBottom: "-1px", zIndex: 1, position: "relative" }}
        >
          <FooterWave2Icon />
        </div>
      )}
      <section
        className={clsx(
          className,
          styles.root,
          showTopWave ? "pt-0" : "pt-5",
          showWave ? "pb-0" : "pb-5",
        )}
      >
        <Container>
          <div className="wrapper">
            <div>
              {heading && <h2 className={`h3 mb-3`}>{heading}</h2>}
              {image && <img src={image?.url} alt={image?.alt} />}
            </div>
            <div>
              {lead_content && (
                <div
                  className={`focused-text`}
                  dangerouslySetInnerHTML={{ __html: lead_content }}
                />
              )}
              {content && (
                <div className={`content`} dangerouslySetInnerHTML={{ __html: content }} />
              )}
              {showSchoolTopics && postsToRender?.length > 0 && (
                <div className="d-flex flex-wrap column-wrapper">
                  {postsToRender.map((item, index) => (
                    <div className="column" key={index}>
                      <ValidatedValueCard post={item} />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </Container>
        {showWave && (
          <div
            className={clsx(
              "footer",
              waveDirection === "down" && "rotate",
              waveColor,
              waveBackground,
            )}
            style={{ marginTop: "-1px" }}
          >
            <FooterWave2Icon />
          </div>
        )}
      </section>
    </>
  );
};

export default ImageWithText;
